const STORAGE_KEY = 'popular-emojis';
const MAX_ITEMS = 20;
const MAX_STORAGE = 50;

interface EmojiCount {
  char: string;
  count: number;
  lastUsed: number;
}

export function getPopularEmojis(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const items: EmojiCount[] = JSON.parse(raw);
    return items
      .sort((a, b) => b.count - a.count || (b.lastUsed ?? 0) - (a.lastUsed ?? 0))
      .slice(0, MAX_ITEMS)
      .map((e) => e.char);
  } catch {
    return [];
  }
}

export function clearPopularEmojis(): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // silently skip
  }
}

export function recordEmojiCopy(char: string): void {
  if (typeof window === 'undefined') return;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const items: EmojiCount[] = raw ? JSON.parse(raw) : [];
    const now = Date.now();
    const existing = items.find((e) => e.char === char);
    if (existing) {
      existing.count++;
      existing.lastUsed = now;
    } else if (items.length < MAX_STORAGE) {
      items.push({ char, count: 1, lastUsed: now });
    } else {
      // Storage full — evict the least-used entry to make room
      items.sort((a, b) => a.count - b.count || (a.lastUsed ?? 0) - (b.lastUsed ?? 0));
      items[0] = { char, count: 1, lastUsed: now };
    }
    items.sort((a, b) => b.count - a.count || (b.lastUsed ?? 0) - (a.lastUsed ?? 0));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  } catch {
    // localStorage unavailable — silently skip
  }
}
